export default {
  getCustomerCalendarEvent: state => state.customerCalendarEvent,
  getCustomerCalendarEvents: state => state.customerCalendarEvents,
}
